
/* global femcare, dataLayer */

/**
 * Google Analytics 4 events.
 * Event listeners to push Google Analytics events.
 */
femcare.tracking.gaTracking = {
    init: function () {

        // Regular GA Analytics
        // TODO Remove after GA4 integration
        var isErrorPage = $('meta[name="keywords"]').attr('content') === 'error';
        this.promotionInteraction();
        this.fileDownloadInteraction();

        // Navigation interaction
        // Navigation Category interaction
        // TODO Remove after GA4 integration
        $('.navigation-bar__topic, .mobile-navigation__accordion-header').on('click', function () {
            var element = $(this);
            var categoryName;

            if (element.hasClass('navigation-bar__topic')) {
                categoryName = element.find('span').text();
            } else {
                categoryName = element.find('.mobile-navigation__topic').text();
            }

            categoryName = categoryName.replace(/\s+/g, ' ').trim();

            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    event: 'gaEvent',
                    eventTrigger: 'NavigationMenu',
                    eventCategory: 'Top Navigation Category',
                    eventAction: categoryName,
                    eventLabel: categoryName,
                });
            }
        });

        // Navigation Sub-Category interaction
        // TODO Remove after GA4 integration
        $('.navigation-bar__link, .mobile-navigation__link').on('click', function () {
            var subCategoryName = $(this).text().replace(/\s+/g, ' ').trim();
            var category = $(this).parents('.navigation-bar__submenu, .mobile-navigation__submenu').parents('li');
            var categoryName = category.find('a span, .mobile-navigation__topic').text().replace(/\s+/g, ' ').trim();

            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    event: 'gaEvent',
                    eventTrigger: 'NavigationMenu',
                    eventCategory: 'Top Navigation Category',
                    eventAction: categoryName,
                    eventLabel: subCategoryName,
                });
            }
        })

        // Select language interaction
        // TODO Remove after GA4 integration
        $('.navigation-bar__language-popout a').on('click', function () {
            var selectedLanguage = $(this).data('language');

            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    event: 'gaEvent',
                    eventTrigger: 'languageSelector',
                    eventCategory: 'Navigation',
                    eventAction: 'Language Selector',
                    eventLabel: selectedLanguage
                });
            }
        });

        // Social share interaction
        // TODO Remove after GA4 integration
        $('.share-button').on('click', function (e) {
            e.preventDefault();
            var channel = $(this).data('channel');

            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    event: 'gaEvent',
                    eventTrigger: ' socialInteraction',
                    eventCategory: 'Social Share',
                    eventAction: channel,
                    eventLabel: window.location.href
                });
            }
        });

        // TODO Remove after GA4 integration
        if (isErrorPage) {
            $(document).trigger('ga-pageError');
        }

        // TODO Remove after GA4 integration
        $('a[data-ga-title]').on('click', function () {
            var $link = $(this);

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'gaEvent',
                eventTrigger: 'articleClick',
                eventCategory: 'Article Click',
                eventAction: $link.attr('data-ga-title'),
                eventLabel: window.location.href,
                eventValue: undefined
            });
        });

        // GA4 Analytics
        // Social share interaction
        $('.social__link').not('.social--follow .social__link').on('click', function (e) {
            var channel = $(this).data('gaChannel');

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'ga4_share',
                'ga4_data': {
                    'method': channel
                }
            })
        });

        /**
         * Tracks clicks on the 'trackMyPeriod' button.
         */
        $('#trackMyPeriod').on('click', function () {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'ga4_track_my_period',
                ga4_data: {
                    action_type: 'Click on track my period CTA'
                }
            });
        });

        /**
         * Tracks product clicks on links within the 'cta-panel'. And dependent on event-type it adds product_click or select_item event.
         * Tracking should not be supported for products within search result container.
         */
        $('.cta-panel:not(.cta-panel__article) a').on('click', function (e) {
            e.stopPropagation();
            var productCtaPanel = $(e.target).closest('.cta-panel');
            var isSearchResultParent = productCtaPanel.parents('.search-results__container').length;
            var eventType = productCtaPanel.data('ga-event-type');
            var isEccomerce = false;

            if (eventType === 'select_item') {
                isEccomerce = true;
            }

            if (!isSearchResultParent) {
                femcare.tracking.product.selectProductAnalytics(productCtaPanel, isEccomerce);
            }
        });

        /**
         * Tracks product clicks on 'cta-panel' without inner links and buttons. And dependent on event-type it adds product_click or select_item event.
         * Tracking should not be supported for products within search result container.
         */
        $('.cta-panel:not(.cta-panel__article)').on('click', function (e) {
            if (e.target.closest('a') || e.target.closest('button')) { 
                return; 
            }
            var productCtaPanel = $(e.target).closest('.cta-panel');
            var isSearchResultParent = productCtaPanel.parents('.search-results__container').length;
            var eventType = productCtaPanel.data('ga-event-type');
            var isEccomerce = false;

            if (eventType === 'select_item') {
                isEccomerce = true;
            }

            if (!isSearchResultParent) {
                femcare.tracking.product.selectProductAnalytics(productCtaPanel, isEccomerce);
            }
        });


        /**
         * Tracks product keyboard enter click on 'cta-panel'. And dependent on event-type it adds product_click or select_item event.
         * Tracking should not be supported for products within search result container.
         */
        $('.cta-panel').on('click keydown', function (e) {
            if (e.type === 'keydown' && e.key === 'Enter') {
                if (e.target.closest('a') || e.target.closest('button')) { 
                    return; 
                }
                var productCtaPanel = $(e.target).closest('.cta-panel');
                var isSearchResultParent = productCtaPanel.parents('.search-results__container').length;
                var eventType = productCtaPanel.data('ga-event-type');
                var isEccomerce = false;

                if (eventType === 'select_item') {
                    isEccomerce = true;
                }

                if (!isSearchResultParent) {
                    femcare.tracking.product.selectProductAnalytics(productCtaPanel, isEccomerce);
                }
            }
        });

        /**
     * Tracks click events on phone numbers.
     * @param {jQuery.Event} event - The jQuery click event.
     */
        $('a[href^="tel:"]').on('click', function () {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'ga4_phone_click'
            });
        });

        /**
     * Tracks click events on email links.
     * @param {jQuery.Event} event - The jQuery click event.
     */
        $('a[href^="mailto:"]').on('click', function () {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'ga4_email_click'
            });
        });

        /**
     * Tracks click events on external links.
     * @param {jQuery.Event} event - The jQuery click event.
     */
        $('a').not('[href^="#"]').not('[href^="mailto:"]').not('[href^="tel:"]').not(function () {
            return this.hostname && this.hostname === location.hostname;
        }).on('click', function () {
            var linkURL = $(this).prop('href');
            if (linkURL) {
                var currentDomain = femcare.shared.util.getCurrentDomain();
                var linkDomain = femcare.shared.util.extractDomain(linkURL);
                var linkText = $(this).text();
                var outbound = linkDomain !== currentDomain;

                if (outbound) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'ga4_click',
                        ga4_data: {
                            link_url: linkURL,
                            link_domain: linkDomain,
                            link_text: linkText,
                            outbound: outbound
                        }
                    });
                }
            }
        });
    },

    /**
     * Tracks promotion clicks for the hero banner, banner, carousel, promobox, article box, recommended and signpost articles
     */
    promotionInteraction: function () {
        const promotionTrackableElements = [
            { selector: '.hero-slide a', label: 'Hero Banner' },
            { selector: '.signpost-topic a, .signpost-basic a', label: 'Promo box' },
            { selector: '.signpost-info-item a', label: 'Article box' },
            { selector: '.signpost-topic-item a', label: 'Banner' },
            { selector: '.suggested-products__slider a', label: 'Recommended article' },
            { selector: '.signpost-article a', label: 'Article box' }
        ];

        promotionTrackableElements.forEach((element) => {
            $(element.selector).on('click', (event) => {
                let promotionName = $(event.currentTarget).data('ga-promotion-name');
                if (promotionName) {
                    this.promotionClick(element.label, promotionName);
                }
            });
        });
    },

    /**
 * Tracks file download interactions by adding GA4 tracking for signpost elements.
 */
    fileDownloadInteraction: function () {
        const fileDownloadTrackableElements = [
            { selector: '.signpost-topic-item a' }
        ];

        fileDownloadTrackableElements.forEach((element) => {
            $(element.selector).on('click', (event) => {
                let clickedLink = $(event.currentTarget);
                let eventType = clickedLink.data('ga-event-type') || clickedLink.parents('a').data('ga-event-type');
                let eventId = clickedLink.data('ga-event-id') || clickedLink.parents('a').data('ga-event-id');

                if (eventType === 'ga4_file_download') {
                    if (eventId) {
                        femcare.tracking.gaTracking.addAnalytics(eventId.toString(), eventType, false);
                    }
                }
            });
        });
    },

    promotionClick: function (creativeName, promotionName) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'ga4_select_promotion',
            ga4_data: {
                creative_name: creativeName,
                promotion_name: promotionName
            }
        });
    },

    /**
 * Tracks form submissions.
 * @param {jQuery} $form - The jQuery object representing the form.
 */
    // TODO Remove after GA4 integration
    formSubmit: function ($form) {
        var eventLabel = $form.data('ga-form-name');
        var eventTrigger = $form.data('ga-trigger');

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'gaEvent',
            eventTrigger: eventTrigger || 'formSubmit',
            eventCategory: 'Form',
            eventAction: 'Submit',
            eventLabel: eventLabel || undefined,
            eventValue: undefined
        });
    },

    /**
 * Adds analytics for all events that are defined in json gaDataLayer
 * @param {string} eventId - The eventId epresents ga4 event id.
 * @param {string} eventType - The eventType epresents ga4 event type.
 * @param {boolean} isEcommerce
 */
    addAnalytics: function (eventId, eventType, isEcommerce) {
        var gaObj = femcare.shared.util.getEntryFromObject(window.gaDataLayer, 'Id', eventId);
        window.dataLayer = window.dataLayer || [];

        if (isEcommerce) {
            window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object
            window.dataLayer.push({
                event: eventType,
                ecommerce: {
                    items: [
                        gaObj[0].Data
                    ]
                }
            });
        } else {
            window.dataLayer.push({
                event: eventType,
                ga4_data: gaObj[0].Data
            });
        }
    }
};

/**
 * Page errors
 */
// TODO Remove after GA4 integration
$(document).on('ga-pageError', function () {
    if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
            event: 'gaEvent',
            eventTrigger: 'pageError',
            eventCategory: 'Page Error',
            eventAction: 'Error 404',
            eventLabel: document.referrer
        });
    }
});
